import { Ref } from "vue";

/**Управление позицией каретки */
export const useSaveCaretPosition = ($editor: Ref<HTMLElement>) => {
  let caretInfo: { path: number[]; offset: number } | null = null;

  /**Сохранить позицию каретки */
  const saveCaretPosition = () => {
    try {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const path = getNodePath(range.startContainer);
        caretInfo = {
          path,
          offset: range.startOffset,
        };
      }
    } catch (e) {
      console.error(e);
    }
  };

  /**Восстановить позицию каретки */
  const restoreCaretPosition = () => {
    try {
      const selection = window.getSelection();
      const range = document.createRange();

      if (caretInfo) {
        const { path, offset } = caretInfo;
        const node = getNodeFromPath($editor.value, path);

        if (node) {
          range.setStart(node, offset);
          range.collapse(true);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  /**Вспомогательная функция для получения пути к узлу */
  const getNodePath = (node: Node): number[] => {
    const path: number[] = [];
    let currentNode: Node | null = node;

    while (currentNode && currentNode !== $editor.value) {
      const parentNode = currentNode.parentNode;
      if (parentNode) {
        // @ts-ignore
        const index = Array.from(parentNode.childNodes).indexOf(currentNode);
        path.unshift(index);
        currentNode = parentNode;
      } else {
        break;
      }
    }

    return path;
  };

  /**Вспомогательная функция для получения узла из сохраненного пути */
  const getNodeFromPath = (root: Node, path: number[]) => {
    let currentNode: Node | null = root;

    for (const index of path) {
      if (currentNode && currentNode.childNodes.length > index) {
        currentNode = currentNode.childNodes[index];
      } else {
        return null;
      }
    }

    return currentNode;
  };

  return {
    /**Сохранить позицию каретки */
    saveCaretPosition,
    /**Восстановить позицию каретки */
    restoreCaretPosition,
  };
};
